import SocialIcons from "./components/SocialIcons";
import SubscribeCard from "./components/SubscribeCard";
import FooterNavigationLinks from "./components/FooterNavigationLinks";

import { useRef, useEffect } from "react";
import { motion, useInView, useAnimation } from "framer-motion";
import AgntLogo from "./components/AgntLogo";
import WhatPressSay from "../WhatPressSay";

const LandingFooter = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const parentVariants = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.5, // Adjust delay between children
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <motion.footer
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={{
        hidden: { opacity: 0, y: 50 },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 1,
            ease: "easeOut",
            staggerChildren: 0.5,
            delay: 0.5,
          },
        },
      }}
      className="landing-footer px-[2.285vw] bg-[#F3F3F8] max-lg:px-[4.3vw] max-lg:pt-[6.4vw] max-lg:mt-[14vw] max-lg:pb-[8.53vw] rounded-t-60 max-lg:rounded-t-[40px] py-[2.285vw] shadow-custom mt-[8vw]"
    >
      <motion.div
        className="w-full flex flex-col gap-[2.285vw] max-lg:gap-[8.53vw] max-lg:mb-[13.86vw] mb-[3.61vw]"
        variants={parentVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <motion.div
          className="flex items-center justify-between max-lg:flex-col max-lg:gap-[3vw] max-lg:items-start"
          variants={parentVariants}
        >
          <motion.button onClick={scrollToTop} variants={itemVariants}>
            <AgntLogo />
          </motion.button>

          <motion.div variants={itemVariants}>
            <SocialIcons />
          </motion.div>
        </motion.div>

        <motion.div
          className="grid grid-cols-[37.928vw_1fr] gap-[2.285vw] max-lg:grid-cols-1 max-lg:gap-[8.53vw]"
          variants={parentVariants}
        >
          <motion.div variants={itemVariants}>
            <SubscribeCard />
          </motion.div>

          <motion.div variants={itemVariants}>
            <FooterNavigationLinks />
          </motion.div>
        </motion.div>
      </motion.div>

      <motion.div
        className="flex justify-center"
        variants={{
          hidden: { opacity: 0, y: 30 },
          visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.8, ease: "easeOut" },
          },
        }}
      >
        <p className="font-luxora-regular leading-[1.1] text-[#00000099] text-16 max-lg:text-[4.26vw]">
          {`All rights reserved ${new Date().getFullYear()} © AGNT.Hub`}
        </p>
      </motion.div>
    </motion.footer>
  );
};

export default LandingFooter;
